import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd2991b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orders-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-primary col-12 px-2 py-3 py-md-5 flex-centered-col bg-image mb-2 mb-md-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "m-0 text-uppercase text-white" }, "My Orders")
], -1))
const _hoisted_3 = { class: "rounded shadow bg-light position-relative px-3 pt-4 pt-sm-5 pb-2 pb-sm-4" }
const _hoisted_4 = { class: "product-list py-3 px-5" }
const _hoisted_5 = {
  key: 0,
  class: "'bi bi-chevron-down ms-3"
}
const _hoisted_6 = { class: "filter-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm btn-outline-primary" }, "Clear", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "d-flex flex-centered mt-4" }

import { useHead } from "@unhead/vue";
import { useUserStore, StorePartitions, Order, OrderHistory } from "@/stores/user";
import { useMiscStore } from "@/stores/misc";
import { onBeforeMount, Ref, ref } from "vue";
import { formatDate, calculatePrice, thousandSeparator } from "@/utilities";
import Spinner from "@/components/spinner/Spinner.vue";
import { tableResizeObserver } from "@/utilities";
import { watch } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersView',
  setup(__props) {

useHead({
  title: "My Orders",
});

let orders: Ref<Array<Order>> = ref([]);
let profileOrderInfo: Ref<OrderHistory> = ref({
  page_size: 0,
  page_number: 0,
  total_records: 0,
  stores: [],
  data: []
});
let partitionKeys: Ref<Array<StorePartitions>> = ref([]);
let currentPage: Ref<number> = ref(1);
let currency: Ref<string> = ref("Rands");
const PageSize: Ref<number> = ref(20);
const StoreSearchPopup: Ref<any> = ref(null);
const OrdersTable: Ref<any> = ref(null);
let storeFilter: Ref<string | undefined> = ref(undefined);

const userStore = useUserStore();
const miscStore = useMiscStore();

tableResizeObserver(this);

onBeforeMount(async () => {
  await loadData();
  partitionKeys.value = profileOrderInfo.value.stores;
});

watch(profileOrderInfo, () => {
  orders.value = profileOrderInfo.value.data.items;
})

async function loadData () {
  miscStore.isLoading = true;
  profileOrderInfo.value = await userStore.getOrders(currentPage.value, PageSize.value, storeFilter.value).catch(() => {miscStore.isLoading = false; return false;});
  OrdersTable.value.setScrollTop(0);
  miscStore.isLoading = false;
}

function priceFormat (price: number, isCents: boolean = false) {
  let cost = price;
  if (isCents) {
    cost = price / 100;
  }
  const p = calculatePrice(cost, 1);
  return thousandSeparator(p);
}

async function filterHandler (value: string | undefined = undefined) {
  StoreSearchPopup.value.hide();
  storeFilter.value = value;
  pageChange(1);
}

async function pageChange (value: number) {
  currentPage.value = value;
  await loadData();
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_popover = _resolveDirective("popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Spinner, {
        isAbsolute: true,
        visible: _unref(miscStore).isLoading
      }, null, 8, ["visible"]),
      _createVNode(_component_el_table, {
        data: _unref(orders),
        height: "400",
        class: "w-100",
        type: "expand",
        ref_key: "OrdersTable",
        ref: OrdersTable
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "expand" }, {
            default: _withCtx((props) => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_table, {
                  data: props.row.items
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "Name",
                      prop: "name"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Quantity",
                      prop: "qty_ordered"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: `Price (${_unref(currency)})`,
                      prop: "row_total_incl_tax",
                      align: "right"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(priceFormat(scope.row.row_total_incl_tax)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: `Subtotal (${_unref(currency)})`,
                      align: "right"
                    }, {
                      default: _withCtx((scope) => [
                        _createTextVNode(_toDisplayString(priceFormat(scope.row.row_total_incl_tax * scope.row.qty_ordered)), 1)
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 2
                }, 1032, ["data"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            "class-name": "fw-bold",
            prop: "increment_id",
            label: "Order Number",
            width: "140"
          }),
          _createVNode(_component_el_table_column, {
            prop: "store_name",
            label: "Store",
            "min-width": "150"
          }, {
            header: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("span", {
                class: _normalizeClass({'pointer': _unref(partitionKeys) && _unref(partitionKeys).length})
              }, [
                _createTextVNode(" Store "),
                (_unref(partitionKeys) && _unref(partitionKeys).length)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                  : _createCommentVNode("", true)
              ], 2)), [
                [_directive_popover, StoreSearchPopup.value]
              ]),
              (_unref(partitionKeys) && _unref(partitionKeys).length)
                ? (_openBlock(), _createBlock(_component_el_popover, {
                    key: 0,
                    ref_key: "StoreSearchPopup",
                    ref: StoreSearchPopup,
                    width: "300",
                    trigger: "click",
                    title: "Filter by store",
                    "virtual-triggering": "",
                    persistent: "",
                    "popper-class": "filter-popper"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("ul", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(partitionKeys), (store, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: store.store_id,
                            onClick: ($event: any) => (filterHandler(store.store_id)),
                            class: _normalizeClass({
                    'text-primary fw-bold': _unref(storeFilter) == store.store_id,
                  })
                          }, _toDisplayString(store.store_name), 11, _hoisted_7))
                        }), 128))
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(['text-center', {'invisible': !_unref(storeFilter)}]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (filterHandler()))
                      }, _hoisted_9, 2)
                    ]),
                    _: 1
                  }, 512))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "created_at",
            label: "Order Placed",
            width: "110"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(formatDate)(scope.row.created_at, undefined, true)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "total_due",
            label: `Order Total (${_unref(currency)})`,
            align: "right",
            width: "140"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(priceFormat(scope.row.total_due)), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_pagination, {
          background: "",
          "hide-on-single-page": "",
          "current-page": Number(_unref(currentPage)),
          layout: "prev, pager, next",
          "page-count": Math.ceil(_unref(profileOrderInfo).total_records / 20),
          total: _unref(profileOrderInfo).total_records,
          "page-size": PageSize.value,
          "pager-count": 7,
          onCurrentChange: pageChange
        }, null, 8, ["current-page", "page-count", "total", "page-size"])
      ])
    ])
  ]))
}
}

})